import { render, staticRenderFns } from "./DeleteContentLabelModalFooter.vue?vue&type=template&id=3f64627a&"
import script from "./DeleteContentLabelModalFooter.vue?vue&type=script&lang=js&"
export * from "./DeleteContentLabelModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports